import { useEffect, useState } from 'react';

const usePagination = (
  initialPage = 1,
  totalPages = 0,
  onPageChange?: (currentPage: number) => void
) => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  useEffect(() => {
    setCurrentPage(initialPage);
  }, [initialPage]);

  const goToPage = (page: number) => {
    const validatedPage = Math.max(1, Math.min(page, totalPages));
    setCurrentPage(validatedPage);
  };

  const nextPage = () => {
    goToPage(currentPage + 1);
  };

  const prevPage = () => {
    goToPage(currentPage - 1);
  };

  useEffect(() => {
    if (onPageChange) {
      onPageChange(currentPage);
    }
  }, [currentPage, onPageChange]);

  return {
    currentPage,
    goToPage,
    nextPage,
    prevPage,
    totalPages
  };
};

export default usePagination;
